import AnalysysAgent from 'ans-javascript-sdk';

AnalysysAgent.init({
    appkey: process.env.VUE_APP_YIGUAN_APPKEY, // APPKEY
    uploadURL: 'https://ark-collector.aikucun.com', // 上传数据的地址
    debugMode: parseInt(process.env.VUE_APP_ANALYSYS_DEBUGMODE, 0),
    auto: false,
    sendType: 'post'
});

export default {
    track(eventName, eventInfo) {
        return AnalysysAgent.track(eventName, eventInfo);
    },

    // 设置用户属性
    profileSet(property) {
        return AnalysysAgent.profileSet(property);
    },

    // 设置用户固有属性
    profileSetOnce(property) {
        return AnalysysAgent.profileSetOnce(property);
    },

    // 匿名ID与用户关联
    alias(id) {
        return AnalysysAgent.alias(id);
    },

    // 注册页面事件通用属性
    registerSuperProperties(property) {
        return AnalysysAgent.registerSuperProperties(property);
    },

    // 清除页面事件通用属性
    unRegisterSuperProperty(property) {
        return AnalysysAgent.unRegisterSuperProperty(property);
    },

    // 清除所有页面事件通用属性
    clearSuperProperties() {
        return AnalysysAgent.clearSuperProperties();
    },

    // pv
    pageView(property, previousPageName) {
        let parmas = {};
        if (typeof property === 'string') {
            parmas.page_name = property;
        } else {
            parmas = property;
        }
        previousPageName && (parmas.previous_page_name = previousPageName);
        return AnalysysAgent.pageView(parmas);
    }
};
